export default __webpack_public_path__ + "static/media/magic.a8ae7d28.svg";